// Third party
import React from 'react';

// Utils
import FormattedMessage from '@/utils/i18n/FormattedMessage';

const NoSearchResults = () => (
  <div className="no-search-results">
    <FormattedMessage id="Proposal.NoContentWasFound" />
  </div>
);

export default NoSearchResults;
